<script setup>
import { computed } from 'vue'
import { v4 as uuidv4 } from 'uuid'

const props = defineProps({
  modelValue: {
    type: Number,
    default: null
  },
  label: {
    type: String,
    default: ''
  },
  min: Number,
  max: Number,
  step: {
    type: Number,
    default: 1
  },
  error: String,
  required: {
    type: Boolean,
    default: false
  },
})

const emit = defineEmits(['update:modelValue'])
const inputId = uuidv4()
const localValue = computed({
  get: () => props.modelValue,
  set: (val) => {
    emit('update:modelValue', val === '' ? null : Number(val))
  }
})
</script>

<template>
  <div :class="['mb-3', (error) ? 'input-field text-danger' : 'input-field']">
    <label v-if="label" :for="inputId" class="form-label active">
      {{ label }}
      <span v-if="required" class="text-danger">*</span>
    </label>

    <input
      :id="inputId"
      type="number"
      autocomplete="off"
      :class="[
        'form-control',
        error ? 'is-invalid' : ''
      ]"
      v-model="localValue"
      :min="min"
      :max="max"
      :step="step"
    />

    <p v-if="error" class="text-danger mt-0">{{ error }}</p>
  </div>
</template>